import { render, staticRenderFns } from "./application-detail.vue?vue&type=template&id=35052804&scoped=true"
import script from "./application-detail.vue?vue&type=script&lang=js"
export * from "./application-detail.vue?vue&type=script&lang=js"
import style0 from "./application-detail.vue?vue&type=style&index=0&id=35052804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35052804",
  null
  
)

export default component.exports